import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const deleteExternalTeacher = createApiThunk<void, string>(
  "educationalAdvisor/externalTeacher/delete",
  async (id, { extra: { educationalAdvisorRepository } }) => {
    await educationalAdvisorRepository!.deleteExternalTeacher(id);
  },
);

export const resetDeleteExternalTeacher = createAction("educationalAdvisor/externalTeacher/resetDelete");
